import React, { useState, useEffect } from "react";
import "./LoadingPage.css";

const LoadingPage: React.FC = () => {
  const [videoUrl, setVideoUrl] = useState<string>("");

  useEffect(() => {
    const getVideoQuality = () => {
      const baseUrl = "https://res.cloudinary.com/dzp5qf9dd/video/upload";
      const videoId = "v1766634630/drone_fpbajt.mp4";

      // Check network connection
      const connection = (navigator as any).connection || (navigator as any).mozConnection || (navigator as any).webkitConnection;
      
      // Check screen width
      const screenWidth = window.innerWidth;
      const isHighResScreen = window.devicePixelRatio > 1;

      // Determine quality based on connection and device
      let quality = "q_auto:good"; // default
      
      if (connection) {
        const effectiveType = connection.effectiveType;
        
        if (effectiveType === '4g' && screenWidth > 1920 && isHighResScreen) {
          // High quality for fast connection and large screens
          quality = "q_auto:best,w_1920";
        } else if (effectiveType === '4g' || effectiveType === '3g') {
          // Medium quality for good connections
          quality = "q_auto:good,w_1280";
        } else if (effectiveType === '2g' || effectiveType === 'slow-2g') {
          // Low quality for slow connections
          quality = "q_auto:low,w_854";
        }
      } else {
        // Fallback when Network Information API is not available
        if (screenWidth > 1920 && isHighResScreen) {
          quality = "q_auto:best,w_1920";
        } else if (screenWidth > 1280) {
          quality = "q_auto:good,w_1280";
        } else {
          quality = "q_auto:eco,w_854";
        }
      }

      return `${baseUrl}/${quality}/${videoId}`;
    };

    setVideoUrl(getVideoQuality());
  }, []);

  return (
    <div className="loading-page">
      <video className="background-video" autoPlay loop muted playsInline key={videoUrl}>
        <source src={videoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="loading-dialog">
        <div className="loading-spinner"></div>
        <h2>Loading...</h2>
      </div>
    </div>
  );
};

export default LoadingPage;
